export default class UrlParams {
  /**
   * Get url params for host environment
   */
  static getParams() {
    return new URL(window.location.toString()).searchParams;
  }

  /**
   * Get url parameter
   * @param key string
   */
  static get(name) {
    return UrlParams.getParams().get(name);
  }

  /**
   * Checks if url parameter exists
   * @param key string
   */
  static has(name) {
    return UrlParams.getParams().has(name);
  }

  /**
   * Change url Param
   *
   * @param key string
   * @param value string
   */
  static set(key, value) {
    const params = UrlParams.delete(key);
    if (value) {
      params.set(key, value);
    }
    const url = unescape(window.location.pathname + '?' + params);
    window.history.replaceState({}, '', url);
  }

  /**
   * Delete url Param
   *
   * @param key string
   */
  static delete(key) {
    const params = new URLSearchParams(window.location.search.slice(1));
    params.delete(key);
    return params;
  }
}
